/**
 * Resolve the unary gRPC-Web base URL. Pure/injectable for unit tests —
 * production builds must bake VITE_GRPC_ENDPOINT (see staging/production deploy).
 */
export function getGrpcEndpoint(opts?: {
  viteEndpoint?: string
  hostname?: string
  protocol?: string
  /** When false, treats the call as SSR (no window). */
  hasWindow?: boolean
}): string {
  // `"viteEndpoint" in opts` lets tests pass explicit undefined without falling
  // through to import.meta.env (which Vitest may load from .env*).
  const viteEndpoint =
    opts && "viteEndpoint" in opts ? opts.viteEndpoint : import.meta.env.VITE_GRPC_ENDPOINT
  if (viteEndpoint) {
    return viteEndpoint
  }

  const hasWindow = opts?.hasWindow ?? typeof window !== "undefined"
  if (hasWindow) {
    const hostname = opts?.hostname ?? window.location.hostname
    const protocol = opts?.protocol ?? window.location.protocol

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return `${protocol}//${hostname}:8000`
    }

    throw new Error(
      "VITE_GRPC_ENDPOINT is required outside localhost (refusing hardcoded api.csms.cloud fallback)"
    )
  }

  return "http://localhost:8000"
}
